import React from 'react'

const SubServiceDetailNew1 = () => {
  return (
    <div className="text-black  text-center xl:text-left dark:text-white bg-zinc-50 dark:bg-zinc-800 min-h-[90vh] relative xl:py-20 xl:px-35 px-10 py-20 " style={{ backgroundImage: 'url(/new-final-data/sections/16.webp)', backgroundSize: 'cover', backgroundPosition: 'bottom' }}>
      {/* Background overlay for better text readability */}
      <div className="absolute inset-0 h-[25vh] top-0 z-20 w-full bg-gradient-to-b dark:from-zinc-800 from-zinc-50 to-transparent"></div>
      
      <div className="max-w-4xl relative z-10 ">
              {/* Main heading section */}
        <div className="my-12">
          <h2 className="xl:text-8xl text-6xl font-black mb-8 relative ">
            <img
              className="absolute left-[35%] top-[-40%] mb-4 xl:w-56 xl:h-56 w-42 h-42"
             src="/new-final-data/sections/76.webp"
             alt="" />
            <span className="block text-black dark:text-white xl:text-5xl text-3xl">What is</span>
            <span className="block text-black dark:text-white">Branding?</span>
          </h2>
        </div>

        {/* Description */}
        <p className=" font-[100] w-full text-xl leading-relaxed text-zinc-800 dark:text-zinc-300 mb-8 max-w-3xl">
          Branding is the art of creating a name, logo, or design that sets a product apart from competitors. A strong brand strategy builds recognition, trust, and loyalty-giving businesses a powerful edge in competitive markets.
        </p>

        {/* CTA Link */}
        <a 
          href="#" 
          className="inline-block text-black dark:text-white border-b border-black dark:border-white pb-1 hover:border-gray-600 dark:hover:border-gray-400 hover:text-gray-600 dark:hover:text-gray-400 transition-colors duration-200"
        >
          View Branding Projects
        </a>
      </div>
    </div>
  )
}

export default SubServiceDetailNew1